import { IGameObject } from "../IGameObject";
import GraphQLSDK from "../GraphQLSDK";
import { FLAG_CAPTURE_DISTANCE } from "../Constants";
import { getVectorBetween } from "../helpers";

let dateOfLastCapture = new Date(); // TODO less gross.

export function updateFlag({
    flag,
    player,
}: {
    flag: IGameObject;
    player: IGameObject;
}): void {
    // vector from player to flag

    // distance = flag-player
    const playerToFlag = getVectorBetween(player.position, flag.position);

    const distance = playerToFlag.length();

    if (distance < FLAG_CAPTURE_DISTANCE) {
        if (new Date().getTime() > dateOfLastCapture.getTime() + 5000) {
            GraphQLSDK.captureFlag({ playerId: player.id, flagId: flag.id });
            dateOfLastCapture = new Date();
        }
    }
}
